/**
 * @fileoverview Prompt template for image-editor-fal-v2.
 *
 * This agent doesn't use a text prompt template - it edits images directly
 * using the source image and editing instructions. This file exists for
 * consistency with the agent-per-folder pattern.
 */

export const prompt = '';
